import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";
import { FaInfoCircle, FaExclamationCircle } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";
import { shadeAlternate } from "../../../styled/helpers";

const Block = styled("div")`
  ${CS.flex.line_center};
  font-size: 14px;
  line-height: 1.3;
  padding: 5px 10px;
  border-radius: 3px;
`;

const Error = styled(Block)`
  color: ${({theme}) => theme.colors.error};
  background: ${({theme}) => lighten(0.43, theme.colors.error)};
`;

const Success = styled(Block)`
   color: ${({theme}) => theme.colors.success};
  background: ${({theme}) => lighten(0.43, theme.colors.success)};
`;

const Info = styled(Block)`
  color: ${({theme}) => theme.box.text};
  background: ${({theme}) => shadeAlternate(0.1, theme.box.background)};
`;

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  text?: React.ReactNode;
}

export const BlockInfo = (props: Props) => (
  <Info {...props}>
    <FaInfoCircle className="m-r-2"/>
    <span>{props.text || props.children}</span>
  </Info>
);

export const BlockError = (props: Props) => (
  <Error {...props}>
    <FaExclamationCircle className="m-r-2"/>
    <span>{props.text || props.children}</span>
  </Error>
);

export const BlockSuccess = (props: Props) => (
  <Success {...props}>
    <FaExclamationCircle className="m-r-2"/>
    <span>{props.text || props.children}</span>
  </Success>
);
